if (import.meta.env.DEV) {
  await import('./manifest.js');
}

import Logger from './logger.js';
import './banner.js';

import startup from './startup.js';
startup();
